
import { FormProvider } from "react-hook-form";
import { Login } from "../modules/login";
import { useLogin } from "../modules/login/hooks/useLogin";

export const LoginPage = () => {
  const { formsMethods } = useLogin();

  return (
    <FormProvider {...formsMethods}>
      <Login />
    </FormProvider>
  );
};
